import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";
import { useIsMobile } from "../../../../hooks/useIsMobile";

interface DataAnalyticsChartSkeletonProps {
  chartHeight?: number;
  showTopControls?: boolean;
  showFooterRow?: boolean;
  topControlsWidths?: number[];
  footerRowHeight?: number;
  count?: number;
}

const MOBILE_SKELETON_LEGEND_ITEM_HEIGHT = 27;

const MobileSkeletonLegendSkeleton: React.FC<{ count: number }> = ({
  count,
}) => (
  <Stack spacing={1} sx={{ mt: 1 }}>
    {Array.from({ length: count }).map((_, index) => {
      const key = `skeleton-legend-item-${index}`;

      return (
        <Skeleton
          height={MOBILE_SKELETON_LEGEND_ITEM_HEIGHT}
          key={key}
          variant="rounded"
          width="100%"
        />
      );
    })}
  </Stack>
);

export const DataAnalyticsChartSkeleton: React.FC<
  DataAnalyticsChartSkeletonProps
> = ({
  chartHeight = 400,
  showTopControls = false,
  showFooterRow = true,
  topControlsWidths = [225, 160],
  footerRowHeight = 28,
  count = 3,
}) => {
  const isMobile = useIsMobile();

  return (
    <Stack spacing={2}>
      {showTopControls && (
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexWrap: "wrap",
            alignItems: "flex-end",
          }}
        >
          {topControlsWidths.map((width) => (
            <Skeleton
              key={width}
              sx={{
                width,
                height: 60,
                borderRadius: "16px",
              }}
              variant="rounded"
            />
          ))}
        </Box>
      )}

      <Skeleton
        sx={{
          width: "100%",
          height: chartHeight,
          borderRadius: "24px",
        }}
        variant="rounded"
      />

      {showFooterRow && isMobile && (
        <MobileSkeletonLegendSkeleton count={count} />
      )}

      {showFooterRow && !isMobile && (
        <Skeleton
          sx={{
            width: "100%",
            height: footerRowHeight,
            borderRadius: "8px",
          }}
          variant="rounded"
        />
      )}
    </Stack>
  );
};
